import React from "react";

const IconAndText = ({
  text = "",
  iconBefore,
  iconAfter,
  clsNames = "",
  gap = "8px",
}) => {
  // Simplified icon rendering
  const renderIcon = (icon, position) => {
    if (!icon) return null;

    // If it's a React element, use it directly
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, { className: `icon icon-${position}` });
    }

    // For string (text), render in span
    return typeof icon === "string" ? (
      <span className={`icon icon-${position}`}>{icon}</span>
    ) : null;
  };

  return (
    <div
      className={clsNames}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "2px",
      }}
    >
      {renderIcon(iconBefore, "before")}
      {text && <h5 className="text">{text}</h5>}
      {renderIcon(iconAfter, "after")}
    </div>
  );
};

export default IconAndText;
